module.exports = __webpack_public_path__ + "static/media/migIncompleta.1e6f9d8f.svg";